<template>
  <div class="compact-form-wrapper">
    <div :class="{ 'has-right-actions': $slots.right }" class="form-container">
      <vxe-form
        ref="ref"
        :class="['compact-form', customClass]"
        :data="data"
        :items="items"
        :loading="loading"
        :rules="rules"
        :size="size"
        :span="span"
        :title-align="labelAlign"
        :title-width="labelWidth"
      >
        <slot name="form"></slot>
      </vxe-form>
      <div v-if="$slots.right" class="form-right-actions">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompactForm',
  props: {
    data: Object,
    loading: Boolean,
    span: {
      type: Number,
      default: 6
    },
    labelWidth: {
      type: String,
      default: '100px'
    },
    labelAlign: {
      type: String,
      default: 'right'
    },
    size: {
      type: String,
      default: 'small'
    },
    items: {
      type: Array
    },
    rules: {
      type: Array
    },
    customClass: String
  }
}
</script>

<style scoped>
.compact-form-wrapper {
  width: 100%;
  margin-top: -8px;
  margin-bottom: -8px;
}

.form-container {
  display: flex;
  align-items: flex-start;
  margin-right: -8px; /* 负 margin 抵消右侧操作区域的左边距 */
}

.form-container:not(.has-right-actions) {
  display: block;
}

/* 表单区域 - 自适应宽度 */
.compact-form {
  flex: 1;
  min-width: 0;
  margin-right: 8px; /* 与负 margin 配合 */
}

/* 减少表单内部栅格间距 */
.compact-form ::v-deep .vxe-row {
  margin-left: -4px !important;
  margin-right: -4px !important;
}

.compact-form ::v-deep .vxe-col {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

/* 右侧操作区域 */
.form-right-actions {
  flex-shrink: 0;
  padding-top: 8px;
  white-space: nowrap;
  margin-left: -8px; /* 确保没有额外左边距 */
}

/* 如果使用 VxeUI 的按钮组，调整按钮间距 */
.form-right-actions ::v-deep .vxe-button {
  margin-right: 8px;
  margin-bottom: -10px;
}

.form-right-actions ::v-deep .vxe-button:last-child {
  margin-right: 0;
}
</style>